export default {
  // START:: SET APP LOCALE
  setAppLocale(state, payload) {
    state.shagher_admin_dashboard_language = payload;
  },
  // END:: SET APP LOCALE
};
